import { render } from "./Acessorio.vue?vue&type=template&id=2bd215b6"
import script from "./Acessorio.vue?vue&type=script&lang=js"
export * from "./Acessorio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__